<template>
  <div id="verAudit">
    <!-- router 标题 -->
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <!-- 搜索表单 -->
    <ots-refer
      class="mb20"
      :selectList="selectList"
      :request-form="requestForm"
      @search="searchList"
      
    />
    <!-- table 列表 -->
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :batchOperBtn="batchOperBtn"
      @handleSelectionChange="bachOper"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>

    <!-- 审核通过/不通过弹窗 -->
    <ots-custom-dialog :dialog.sync="isAdoptAudit" :title="adoptDesc.title">
      <template v-slot:content>
        <div class="exportDialog">
          <p class="studentNumber">
            确认将
            <span class="col_red">{{ checkList.length + "个考生" }}</span>
            的人脸验证记录，{{ adoptDesc.title }}！
          </p>
          <el-form>
            <el-form-item class="adoptAudit">
              <span class="adopt_span">审核备注：</span>
              <el-input
                placeholder="请输入审核备注"
                v-model="adopt.auditRemark"
              ></el-input>
            </el-form-item>
            <!-- 审核通过弹窗样式 -->
            <el-form-item
              class="adoptAudit"
              v-if="isSetExamState && currentDialog == true"
            >
              <span class="adopt_span">考试状态设置为正常：</span>
              <el-switch
                v-model="adopt.examState"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </el-form-item>
            <!-- 审核不通过样式 -->
            <el-form-item
              class="adoptAudit"
              v-if="isSetExamState && currentDialog == false"
            >
              <span class="adopt_span">考试异常状态：</span>
              <el-radio-group v-model="adopt.examState">
                <el-radio-button label="3" class="examType"
                  >作弊</el-radio-button
                >
                <el-radio-button label="4" class="examType"
                  >违纪</el-radio-button
                >
                <el-radio-button label="5" class="examType"
                  >替考</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
          </el-form>
          <!-- 审核通过弹窗样式 -->
          <div
            class="impExplain"
            v-if="isSetExamState && currentDialog == true"
          >
            <div>
              <div>
                <span class="col_red"
                  >若选择考试状态置为正常，学生分数为实际试卷分数。</span
                >
              </div>
            </div>
          </div>
          <!-- 审核不通过样式 -->
          <div
            class="impExplain"
            v-if="isSetExamState && currentDialog == false"
          >
            <div>
              <div>
                <span class="col_red"
                  >若选择了异常状态，学生考试分数将置为0。</span
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="isAdoptAudit = false">取消</el-button>
        <el-button
          round
          type="primary"
          @click="adoptAuditIsRight(true)"
          v-if="currentDialog"
          >审核通过</el-button
        >
        <el-button round type="primary" @click="adoptAuditIsRight(false)" v-else
          >审核不通过</el-button
        >
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
/* 
  1.按学生多课程形式导出
  2.默认按一个学生一条课程信息显示
*/
import { getSelectCourse } from "@/http/modules/baseSet/course.js";
import {
  selectHuman,
  batchAuditHumanSet,
  exportHumanSet,
} from "@/http/modules/examSet/varAudit.js";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
export default {
  name: "varAudit",
  data() {
    return {
      /* *** title -- 导出按钮 *** */
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.Export,
        },
      ],
      /* *** select -- 搜索下拉选项 *** */
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          isSearch: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          multiple: true,
          requestKey: "stationId",
          isSearch: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "考试课程",
          type: "select",
          requestKey: "courseId",
          isSearch: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "OTS系统审核",
          type: "select",
          requestKey: "systemAuditStatus",
          isSearch: false,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "人工审核",
          type: "select",
          requestKey: "auditState",
          isSearch: false,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "student",
          placeholder: "姓名/证件号",
        },
      ],
      /* *** requestForm -- 请求参数 *** */
      requestForm: {
        planId: "",
        stationId: [""],
        courseId: "",
        systemAuditStatus: "",
        auditState: "",
        student: "",
        page: 1,
        size: 10,
      },
      /* *** table 表格头配置 *** */
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
          fixed: "left",
        },
        {
          title: "教学点",
          prop: "stationName",
          fixed: "left",
        },
        {
          title: "姓名",
          prop: "userName",
          fixed: "left",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
          title: "交卷时间",
          prop: "submitTime",
        },
        {
          title: "考试分数",
          prop: "score",
        },
        {
          title: "OTS系统审核",
          prop: "systemAuditStatus",
        },
        {
          title: "报名照片",
          prop: "photoUrl",
          type: "imgBig",
        },
        {
          title: "考前验证",
          prop: "beginPhoto",
          type: "imgNormal",
        },
        {
          title: "交卷验证",
          prop: "endPhoto",
          type: "imgNormal",
        },
        {
          title: "随机验证",
          prop: "inProcessPhoto",
          type: "imgArr",
        },
        {
          title: "人工审核",
          prop: "auditState",
          fixed: "right",
        },
        {
          title: "审核备注",
          prop: "auditRemark",
          fixed: "right",
        },
      ],
      /* *** 开启表格 checkbox 按钮 *** */
      tableOption: {
        multiple: true,
      },
      /* *** 表格配置数据 *** */
      tableData: [],
      /* *** 表格顶部按钮 *** */
      batchOperBtn: [
        {
          title: "审核通过",
          icon: "iconfont icon-shangyi",
          click: this.adoptAudit,
        },
        {
          title: "审核不通过",
          icon: "iconfont icon-xiayi",
          click: this.notAdoptAudit,
        },
      ],
      /* *** 审核通过弹窗开关 *** */
      isAdoptAudit: false,
      /* *** 当前弹窗为 审核通过/审核不通过 *** */
      currentDialog: true,
      /* *** 分页--总条数 *** */
      pagination: {
        total: 0,
      },
      /* *** 审核数据 *** */
      adopt: {
        isAudit: "",
        planId: "",
        humanIds: "",
        examState: 0,
        auditRemark: "",
      },
      /* *** 审核弹窗内部展示数据 *** */
      adoptDesc: {
        title: "",
      },
      /* *** 多选选中的列表数据 *** */
      checkList: [],
      /* *** 系统设置是否开启了 - 设置考试状态权限 *** */
      isSetExamState: "",
    };
  },
  watch: {
    /* *** 批次监听 *** */
    "requestForm.planId"(val) {
      this.searchList();
    },
  },
  mounted() {
    /* *** 初始化表单数据 *** */
    this.initData();
  },
  methods: {
    /*****************************
     * @searchList 查询按钮,重置页码
     *****************************/
    searchList() {
      this.requestForm.page = 1;
      this.search();
    },

    /*************************
     * @search 表单搜索操作
     ************************/
    search() {
      let params = { ...this.requestForm };
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }
      selectHuman(params).then((res) => {
        this.tableData = res.data.records;
        this.pagination.total = res.data.total;
      });
    },

    /*************************
     * @initData 初始化数据(表单)
     ************************/
    async initData() {
      /* *** 考试批次列表数据 *** */
      const planList = await this.mixin_getSelectPlan();
      // this.selectList[0].data = [{id: "", name: "全部"}, ...planList]
      /* *** 考试批次取消全部选项 *** */
      this.selectList[0].data = [...planList];
      this.requestForm.planId = planList[0].id;

      /* *** 教学点列表数据 *** */
      const stationList = await this.mixin_getSelectStation();
      this.selectList[1].data = [{ id: "", name: "全部" }, ...stationList];
      /* *** 考试课程列表 *** */
      const courseList = await getSelectCourse({ state: 1 });
      this.selectList[2].data = [{ id: "", name: "全部" }, ...courseList.data];
      /* *** 人脸验证状态 *** */
      this.selectList[3].data = [
        { id: "", name: "全部" },
        { id: 1, name: "通过" },
        { id: 0, name: "未通过" },
      ];
      /* *** 人脸验证审核状态 *** */
      this.selectList[4].data = [
        { id: "", name: "全部" },
        { id: "0", name: "未审核" },
        { id: "2", name: "审核通过" },
        { id: "1", name: "审核不通过" },
      ];
      /* *** 获取系统配置中 - '考试状态权限' *** */
      this.$api.system.getConfigData().then((res) => {
        res.data.configList.map((e) => {
          if (e.setName == "examStateJurisdiction") {
            this.isSetExamState = e.setValue == 1 ? true : false;
            return false;
          }
        });
      });
      /* *** 获取当前考试批次 *** */
      // const { id } = await this.mixin_getCurrentPlanInfo()
      // this.requestForm.planId = id
    },

    /*************************
     * @Export 导出数据
     ************************/
    Export() {
      let params = { ...this.requestForm };
      params.stationId = params.stationId.join();
      delete params.page;
      delete params.size;
      exportHumanSet(params).then((res) => {
        window.location.href = res.data;
      });
    },

    /*********************************
     * @adoptAudit 开启批量审核通过弹窗
     *********************************/
    adoptAudit() {
      /* 当前弹窗为审核通过弹窗 */
      this.currentDialog = true;
      /* checkList: 选择的考生列表 */
      if (this.checkList.length > 0) {
        /* 审核通过弹窗展示内容 */
        this.adoptDesc.title = "审核通过";
        /* 初始化审核数据 */
        this.adopt.examState = 0;
        this.adopt.auditRemark = "";
        /* 开启审核通过弹窗 */
        this.isAdoptAudit = true;
      } else {
        this.$message.warning("请先选择通过考生！");
      }
    },

    /**************************************
     * @notAdoptAudit 开启批量审核不通过弹窗
     **************************************/
    notAdoptAudit() {
      /* 当前弹窗为审核不通过弹窗 */
      this.currentDialog = false;
      /* checkList: 选择的考生列表 */
      if (this.checkList.length > 0) {
        /* 审核通过弹窗展示内容 */
        this.adoptDesc.title = "审核不通过";
        /* 初始化审核数据 */
        this.adopt.examState = 0;
        this.adopt.auditRemark = "";
        /* 开启审核通过弹窗 */
        this.isAdoptAudit = true;
      } else {
        this.$message.warning("请先选择不通过的考生！");
      }
    },

    /******************************
     * @this 审核通过/不通过弹窗提交
     ******************************/
    adoptAuditIsRight(item) {
      /* 处理审核通过参数 */
      let params = { ...this.adopt };
      /* 考生状态 */
      if (this.adopt.examState == 0) {
        params.examState = "";
      }
      /* 选择的考生Id */
      let humanIds = [];
      this.checkList.map((e) => {
        humanIds.push(e.humanId);
      });
      params.humanIds = humanIds.join(",");
      /* 当前的考试批次 */
      params.planId = this.requestForm.planId;
      /* 审核通过 */
      params.isAudit = item ? 2 : 1;
      /* 批量审核通过 */
      batchAuditHumanSet(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功！");
          /* 刷新表格 */
          this.search();
        }
      });
      /* 关闭审核通过弹窗 */
      this.isAdoptAudit = false;
    },

    /*************************
     * @this 多选按钮触发事件
     * @param(val) 选中行数据
     ************************/
    bachOper(val) {
      this.checkList = val;
    },

    /*************************
     * @changeSize 分页相关
     ************************/
    changeSize(num) {
      this.requestForm.size = num;
      this.search();
    },

    /*************************
     * @changePage 分页相关
     ************************/
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
/* *** 重置表单 label 宽度 *** */
// /deep/ .el-form-item__label {
//   min-width: 120px;
//   width: auto!important;
// }

/* *** 审核通过/审核不通过 - 弹窗样式 *** */
.exportDialog {
  .impExplain {
    margin-top: 32px;
    color: #9299a6;
    .tipTitle {
      flex-shrink: 0;
      display: block;
      margin-bottom: 12px;
    }
    div {
      line-height: 1.8;
    }
  }
}

/* *** 审核弹窗学生数量样式 *** */
.studentNumber {
  margin-bottom: 32px;
}

/deep/ .el-form-item__content.adoptAudit {
  display: flex;
  align-items: center;
}

/* *** 审核弹窗 span 样式 *** */
.adopt_span {
  line-height: 20px;
  display: inline-block;
}

/* *** 审核不通过按钮样式 *** */
.examType {
  width: 80px;
  margin-right: 16px;
  /deep/ .el-radio-button__inner {
    width: 100%;
  }
}
/* *** 弹窗中提示文字颜色 *** */
.col_red {
  color: #fe5958;
}
</style>
